import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Shield, XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-8 pb-8 text-center">
          {/* Logo */}
          <div className="mx-auto mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_protect-workers/artifacts/awekt278_image.png" 
              alt="MyShield Logo" 
              className="h-20 w-auto mx-auto"
            />
          </div>

          <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-12 h-12 text-slate-400" />
          </div>
          
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Payment Cancelled</h1>
          <p className="text-slate-600 mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          
          <div className="space-y-3">
            <Button 
              onClick={() => navigate("/payment")} 
              className="w-full bg-slate-900 hover:bg-slate-800"
              data-testid="try-again-btn"
            >
              Try Again
            </Button>
            <Button 
              variant="outline"
              onClick={() => navigate("/")} 
              className="w-full"
            >
              Back to Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
